import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: string = 'login';
    public seeded: boolean = false;

    public data: any = {
        email: '',
        password: ''
    };

    public testAccounts: any[] = [
        { email: 'admin@infra.test', password: 'admin1234', name: '관리자', role: 'admin' },
        { email: 'infra@infra.test', password: 'infra1234', name: '김인프라(서버)', role: 'infra' },
        { email: 'infra2@infra.test', password: 'infra1234', name: '이네트워크(네트워크)', role: 'infra' },
        { email: 'infra3@infra.test', password: 'infra1234', name: '박스토리지(스토리지)', role: 'infra' },
        { email: 'user@infra.test', password: 'user1234', name: '사용자(김요청)', role: 'user' },
        { email: 'service@infra.test', password: 'service1234', name: '나상호(서비스담당)', role: 'service' },
    ];

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/";
    }

    public async showAlert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async seedTestAccounts() {
        const { code, data } = await wiz.call("seed");
        if (code === 200) {
            this.seeded = true;
            await this.service.render();
        }
    }

    public async fillAccount(account: any) {
        this.data.email = account.email;
        this.data.password = account.password;
        await this.service.render();
    }

    public async login() {
        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.email) {
            await this.showAlert("이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.showAlert("비밀번호를 입력해주세요.");
            return;
        }

        let { code, data } = await wiz.call("login", user);

        if (code == 200) {
            location.href = "/";
            await this.service.render();
        } else {
            await this.showAlert(data.message || "로그인에 실패했습니다.", 'error');
        }
    }
}

export default PageAccessComponent;